export const contactsFuzzySearch = (searchText: string, data: any[]) => {
  const formattedSearchText = searchText.toLowerCase().replace(/\s/g, '')

  return data.filter(item => {
    const formattedPhoneNumber = item.phoneNumber.replace(/\D/g, '')
    const formattedFullName = `${item.firstName} ${item.lastName}`.toLowerCase().replace(/\s/g, '')

    return formattedPhoneNumber.includes(formattedSearchText) || formattedFullName.includes(formattedSearchText)
  })
}